<main id="site-main" dir="rtl">
  <section class="hero" aria-labelledby="hero-title">
    <div class="hero-inner">
      <div class="hero-copy">
        <div class="brand-line"><span></span> سامانه راهداری GPS</div>
        <h1 id="hero-title">سامانه ملی تجهیز ناوگان حمل‌ونقل جاده‌ای به GPS</h1>
        <p class="hero-description">پایش هوشمند ناوگان، تخصیص عادلانه سوخت</p>
        <p class="hero-supervision">تحت نظارت سازمان راهداری و حمل‌ونقل جاده‌ای</p>
        <a class="hero-action" [routerLink]="['/login/profile']">
          <span>ورود و ثبت‌نام</span>
          <mat-icon aria-hidden="true">login</mat-icon>
        </a>
      </div>
      <div class="hero-visual">
        <img src="assets/imgs/hero-banner.png" alt="ناوگان حمل‌ونقل جاده‌ای مجهز به سامانه موقعیت‌یاب">
      </div>
    </div>
    <div class="hero-rule" aria-hidden="true"></div>
  </section>
</main>

<app-footer></app-footer>
